<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Smart Sample</h2>

  <mat-dialog-content style="min-width: 420px; padding-top: 8px;">

    <!-- Source field selector -->
    <mat-form-field *ngIf="data.availableSourceFields?.length" appearance="outline" style="width:100%;">
      <mat-label>Source Field</mat-label>
      <mat-select [value]="selectedSourceField"
                  [disabled]="loading"
                  (selectionChange)="onSourceFieldChange($event.value)">
        <mat-option *ngFor="let field of data.availableSourceFields" [value]="field">{{ field }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Loading -->
    <div *ngIf="loading" style="text-align:center; padding: 32px 0;">
      <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
      <p style="margin-top: 16px; color: #666; font-size: 14px;">Analysing farm data...</p>
    </div>

    <!-- Error -->
    <div *ngIf="!loading && error"
         style="display:flex; align-items:flex-start; gap:8px; color:#c62828; padding: 8px 0;">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>

    <!-- Results -->
    <div *ngIf="!loading && result && !error">

      <!-- Already applied banner -->
      <div *ngIf="alreadyApplied"
           style="background:#e8f5e9; border-radius:4px; padding:8px 12px;
                  margin-bottom:14px; color:#2e7d32; display:flex; align-items:center; gap:6px;">
        <mat-icon style="font-size:18px; height:18px; width:18px;">check_circle</mat-icon>
        Smart Sample already applied — current range matches the recommendation.
      </div>

      <table style="width:100%; border-collapse:collapse;">
        <tr>
          <td class="lbl">Sort field</td>
          <td>{{ result.sort_field ?? 'None (natural row order)' }}</td>
        </tr>
        <tr>
          <td class="lbl">Method</td>
          <td>{{ result.sort_description }}</td>
        </tr>
        <tr>
          <td class="lbl">Recommended range</td>
          <td>
            Rows {{ (result.start_row + 1) | number }} – {{ result.end_row | number }}
            <span style="color:#666; margin-left:4px;">(of {{ result.total_rows | number }} total)</span>
          </td>
        </tr>
        <tr>
          <td class="lbl">Sample size</td>
          <td>
            {{ result.row_count | number }} rows
            <span style="color:#666; margin-left:4px;">
              ({{ formatPct(result.row_count / result.total_rows * 100) }} of farm)
            </span>
          </td>
        </tr>
        <tr>
          <td class="lbl">Variety captured</td>
          <td>
            {{ result.variety_pct }}%
            <span *ngIf="result.target_variety_pct != null" style="color:#666; margin-left:4px;">
              (target {{ result.target_variety_pct }}% — {{ result.window_patterns | number }} of {{ result.total_patterns | number }} unique patterns)
            </span>
          </td>
        </tr>
        <tr>
          <td class="lbl">Current range</td>
          <td>{{ data.currentSampleStart | number }} – {{ data.currentSampleEnd | number }}</td>
        </tr>
        <tr *ngIf="result.cached">
          <td class="lbl">Source</td>
          <td style="color:#00ff00;">Cached result</td>
        </tr>
        <tr *ngIf="!result.cached">
          <td class="lbl">Computed in</td>
          <td>{{ result.elapsed_s }}s</td>
        </tr>
      </table>

      <div *ngIf="result.warnings?.length" style="margin-top:12px;">
        <div *ngFor="let w of result.warnings"
             style="display:flex; align-items:flex-start; gap:4px;
                    color:#42a5f5; font-size:12px; margin-top:4px;">
          <mat-icon style="font-size:14px; height:14px; width:14px; flex-shrink:0; margin-top:1px;">info_outline</mat-icon>
          {{ w }}
        </div>
      </div>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="padding: 8px 24px 16px;">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary"
            (click)="apply()"
            [disabled]="loading || !!error">
      {{ alreadyApplied ? 'Already Applied' : 'Apply' }}
    </button>
  </mat-dialog-actions>
</div>
